import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import activityService from "./activityService";

// Ambil semua activity (list)
export const fetchActivities = createAsyncThunk(
  "activities/fetchActivities",
  async ({ page = 1, size = 10 } = {}) => {
    const response = await activityService.getActivities(page, size);
    return response;
  }
);

// Ambil detail activity by slug
export const fetchActivityBySlug = createAsyncThunk(
  "activities/fetchActivityBySlug",
  async (slug, { rejectWithValue }) => {
    try {
      const data = await activityService.getActivityBySlug(slug);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to load activity");
    }
  }
);

const activitySlice = createSlice({
  name: "activities",
  initialState: {
    activitiesList: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1,
    },
    selectedActivity: null, // ✅ tambahkan ini
    loading: false,
    error: null,
  },
  reducers: {
    clearSelectedActivity: (state) => {
      state.selectedActivity = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch list
      .addCase(fetchActivities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActivities.fulfilled, (state, action) => {
        state.loading = false;
        state.activitiesList = action.payload.data || [];
        state.pagination = action.payload.meta || state.pagination;
      })
      .addCase(fetchActivities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Fetch detail by slug
      .addCase(fetchActivityBySlug.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.selectedActivity = null;
      })
      .addCase(fetchActivityBySlug.fulfilled, (state, action) => {
          console.log("selectedActivity slice",action.payload);
        state.loading = false;
        state.selectedActivity = action.payload;
      })
      .addCase(fetchActivityBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearSelectedActivity } = activitySlice.actions;
export default activitySlice.reducer;
